import * as React from "react";
import { cloneDeep, set } from "lodash";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";

import FlowFormBase from "../../Base/FlowForm/FlowFormBase";
import chapterDefs from "./chapterDefs";
import descriptions from "./Descriptions";
import chapters from "./Chapters";
import {
  useServiceContractForm,
  constants,
  create,
  destroyPostForm,
  createCostsUrl,
} from "../../../../store/serviceContracts";
import FullPageSpinner from "../../../Loaders/FullPageSpinner";
import StepDisplay from "../../../StepDisplay/StepDisplay";

export default function ServiceContractCreateForm({ method = "POST" }) {
  const dispatch = useDispatch();
  const storeName = constants.STORE_NAME;
  const [loading, setLoading] = React.useState(false);
  const formLoaded = Boolean(useServiceContractForm(method));
  const { replace } = useHistory();

  const isManualSign = true;

  const onSuccess = (_, returned) => {
    setLoading(false);
    checkout(true);
    replace(createCostsUrl({ id: returned.id }));
  };

  React.useEffect(() => {
    return () => {
      dispatch(destroyPostForm(false));
    };
  }, []);

  const onError = () => {
    setLoading(false);
  };

  const checkout = (success) => {
    dispatch(destroyPostForm(success));
  };

  // TODO - Ask before save draft
  const onSaveDraft = () => {
    onSubmit(true);
  };

  const onSubmit = (draft = false) => {
    setLoading(true);

    dispatch(
      create({
        successCallback: onSuccess,
        errorCallback: onError,
        preProcess: (data) => preProcess({ data, draft, isManualSign }),
      })
    );
  };

  const renderSteps = () => {
    const steps = ["1. Avtal", "2. Kostnader & Schemaläggning"];

    return <StepDisplay steps={steps} activeIndex={0} />;
  };

  return (
    <>
      {(loading || !formLoaded) && <FullPageSpinner />}

      {renderSteps()}

      <FlowFormBase
        {...{
          storeName,
          chapterDefs: chapterDefs({
            isManualSign,
          }),
          chapters,

          descriptions,
          method,
          onSubmit,
          onSaveDraft,
          displayDocumentFieldKey: "editabledoc.docData_",
          title:
            method === "POST"
              ? "Lägg till serviceavtal"
              : "Uppdatera serviceavtal",
        }}
      />
    </>
  );
}

const preProcess = ({ data, draft, isManualSign }) => {
  const copy = cloneDeep(data);

  copy.draft = draft ? true : false;
  copy.pre_existing = true; // always true
  copy.uses_e_signing = !isManualSign;

  if (!copy.bill_with_lease) {
    copy.bill_with_lease = false;
  }

  if (copy.renew_indefinetely === "no_renewal") {
    copy.renew_indefinetely = false;
    copy.renew_interval = null;
  }

  // always create an editable doc
  if (!copy.editabledoc?.title) {
    set(copy, "editabledoc.title", copy.id_number || "Dokument");
  }

  // can't send null to backend
  if (copy.renew_indefinetely === null) {
    delete copy.renew_indefinetely;
  }

  return copy;
};
